import { render, staticRenderFns } from "./TrashEmployee.vue?vue&type=template&id=4099eb14&"
import script from "./TrashEmployee.vue?vue&type=script&lang=js&"
export * from "./TrashEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports